import React, { useState, useEffect } from "react";
import { Stack, Typography, Rating, Box } from "@mui/material";

const RATING_LABELS = {
  1: "خیلی بد",
  2: "بد",
  3: "معمولی",
  4: "خوب",
  5: "عالی",
};

export default function CommentRating({ score = 5, setScore }) {
  const [hoverScore, setHoverScore] = useState(-1);

  // Reset hover state whenever parent score changes/resets
  useEffect(() => {
    setHoverScore(-1);
  }, [score]);

  const activeScore = hoverScore !== -1 ? hoverScore : score;

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
      <Typography variant="body2" color="text.secondary">
        امتیاز شما:
      </Typography>

      <Rating
        value={score}
        dir="ltr"
        sx={{ direction: "ltr" }}
        onChange={(e, newValue) => {
          if (setScore) setScore(newValue || 1);
        }}
        onChangeActive={(e, newHover) => setHoverScore(newHover)}
      />

      {activeScore > 0 && RATING_LABELS[activeScore] && (
        <Box
          sx={{
            fontSize: "0.85rem",
            fontWeight: 700,
            color:
              activeScore <= 2
                ? "error.main"
                : activeScore === 3
                ? "warning.main"
                : "success.main",
            minWidth: 60,
          }}
        >
          {RATING_LABELS[activeScore]}
        </Box>
      )}
    </Stack>
  );
}